export type MapInputMode =
  | 'idle'
  | 'measure'
  | 'optimize'
  | 'highlight'
  | 'comment-placement'
  | 'player-target';

export const toggleMapInputMode = (
  current: MapInputMode,
  next: Exclude<MapInputMode, 'idle'>,
): MapInputMode => (current === next ? 'idle' : next);
